import React, { useEffect, useState } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { supabase } from '../lib/supabaseClient';
import { MathJaxContext } from 'better-react-mathjax';
import { renderClarifyBlocks } from '../components/renderClarifyBlocks';

const mathJaxConfig = {
  loader: { load: ['input/tex', 'output/chtml'] },
  tex: {
    inlineMath: [['$', '$'], ['\\(', '\\)']],
    displayMath: [['\\[', '\\]']]
  }
};

export default function ClarifyViewPage() {
  const { topicId } = useParams();
  const navigate = useNavigate();
  const [entries, setEntries] = useState([]);
  const [topicName, setTopicName] = useState('');

  useEffect(() => {
    if (!topicId) return;

    const fetchClarifications = async () => {
      const { data: topicData } = await supabase
        .from('clarify_topics')
        .select('name')
        .eq('id', topicId)
        .single();

      if (topicData) setTopicName(topicData.name);

      const { data, error } = await supabase
        .from('clarify_entries')
        .select('*')
        .eq('clarify_topic_id', topicId)
        .order('order_index');

      if (!error) setEntries(data || []);
    };

    fetchClarifications();
  }, [topicId]);

  return (
    <MathJaxContext config={mathJaxConfig}>
      <div className="max-w-4xl mx-auto px-4 py-6">
        {/* Navigation buttons */}
        <div className="flex justify-between items-center mb-4">
          <button
            onClick={() => navigate(-1)}
            className="bg-indigo-100 text-indigo-800 px-4 py-2 rounded shadow hover:bg-indigo-200"
          >
            🔙 Back
          </button>
          <button
            onClick={() => window.close()}
            className="bg-indigo-100 text-indigo-800 px-4 py-2 rounded shadow hover:bg-indigo-200"
          >
            ✖ Close this Page
          </button>
        </div>

        <h1 className="text-2xl font-bold text-indigo-700 mb-6 text-center">
          Topic: {topicName}
        </h1>

        {entries.map((entry, index) => (
          <div key={entry.id || index} className="mb-8 border border-gray-200 rounded p-4 shadow">
            <h2 className="text-lg font-semibold text-indigo-600 mb-2">{entry.title}</h2>
            <div className="space-y-3">{renderClarifyBlocks(entry.content_blocks)}</div>
          </div>
        ))}
      </div>
    </MathJaxContext>
  );
}
